import React from "react";
import { CheckCircle2, Video, ShoppingBag, Sparkles } from "lucide-react";

const items = [
  {
    icon: Sparkles,
    title: "Como criar vídeos que vendem",
    desc: "A estrutura por trás de cada vídeo viral: gancho, desenvolvimento, prova e chamada para a compra.",
  },
  {
    icon: Video,
    title: "Perfil dark: venda sem aparecer",
    desc: "Como construir um perfil que gera vendas todos os dias sem mostrar o rosto e sem criação pesada.",
  },
  {
    icon: ShoppingBag,
    title: "Como escolher produtos vencedores",
    desc: "Critérios claros pra não perder tempo com produto morto — e pegar sempre o que está na onda.",
  },
  {
    icon: CheckCircle2,
    title: "Escalar de R$0 a R$15.000/mês",
    desc: "A ordem exata do que fazer no começo, no meio e no crescimento. Sem achismo, sem enrolação.",
  },
];

const LearnSection = () => {
  return (
    <section className="section" style={{ background: "#000" }}>
      <div className="container">
        <div style={{ textAlign: "center", marginBottom: 60 }}>
          <div className="eyebrow">(o que muda no seu resultado)</div>
          <h2 className="h-title" style={{ marginTop: 14, maxWidth: 900, marginInline: "auto" }}>
            O que você vai <span className="yellow">aprender</span>
          </h2>
          <p style={{ maxWidth: 780, margin: "26px auto 0", color: "rgba(255,255,255,0.75)", fontSize: 17, lineHeight: 1.7 }}>
            Aqui você aprende o passo a passo de uma estrutura validada que transforma um vídeo comum em um vídeo que vende — mesmo que você nunca tenha gravado antes.
          </p>
        </div>
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: 22,
        }}>
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div key={i} className="mod-card" style={{ padding: 30, textAlign: "left" }}>
                <div style={{
                  width: 56, height: 56, borderRadius: 14,
                  background: "linear-gradient(135deg, rgba(245,196,0,0.18), rgba(245,196,0,0.02))",
                  border: "1px solid rgba(245,196,0,0.35)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: "#F5C400",
                  marginBottom: 20,
                }}>
                  <Icon size={26} strokeWidth={2} />
                </div>
                <h3 style={{ fontSize: 18, fontWeight: 800, lineHeight: 1.3 }}>{it.title}</h3>
                <p style={{ marginTop: 12, color: "rgba(255,255,255,0.65)", fontSize: 14.5, lineHeight: 1.6 }}>{it.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LearnSection;
